// TODO: Check if this can be re-enabled with newer version of Highcharts.
export function renderInvalidatedColors(rendered, invalidated) {
  // This is no longer applied because of issues with hover states not being
  // updated. Instead, on color change, entire chart is re-rendered.
  if (__ALL__) {
    // const colors = (function (invalidated) {
    //   return invalidated.filter(item => {
    //     return item.indexOf('chart/colors') === 0;
    //   });
    // })(invalidated);
    //
    // const updatePointColor = function (dataPoint, color) {
    //   const el = (dataPoint && dataPoint.graphic) ? dataPoint.graphic.element : null;
    //   if (el) {
    //     el.setAttribute('fill', color);
    //   }
    // };
    //
    // const updateLegendColor = function (render, index, color) {
    //   const items = render.container.querySelectorAll('.highcharts-legend-item');
    //   if (items && items.length) {
    //     const text = items[index].querySelector('text');
    //     text.style.color = text.style.fill = color;
    //   }
    // }
    //
    // if (colors.length) {
    //   colors.forEach(item => {
    //     const bits = item.split('/');
    //     const series = +bits[2];
    //     const point = bits[3];
    //     const color = bits[4];
    //     const chartSeries = rendered.inner.series[series];
    //     let dataPoint = null;
    //     let el = null;
    //
    //     if (chartSeries) {
    //       // if (point.indexOf('#') === 0) {
    //         // updateLegendColor(rendered.inner, series, point);
    //         // Color for entire series.
    //         // chartSeries.color = point;
    //         // Setting render to true re-renders *everything* while false makes
    //         // the lines and legend vanish (if it supposedly does not re-render,
    //         // then like wtf?).
    //         // chartSeries.update({ color: point }, true);
    //
    //       if (chartSeries.graph) {
    //         // Line charts.
    //         chartSeries.graph.element.setAttribute('stroke', color);
    //       } else {
    //         // Bar, column, pie charts.
    //         if (point === '*') {
    //           chartSeries.data.forEach(dataPoint => {
    //             updatePointColor(dataPoint, color);
    //           });
    //         } else {
    //           //originalIndex
    //           let ptIndex = +point;
    //           if (rendered.inner.options.chart.type === 'pie') {
    //             // Find the correct index if the data has been optimized.
    //             for (let i = 0; i < chartSeries.data.length; i++) {
    //               if (!chartSeries.data[i].hasOwnProperty('originalIndex')) {
    //                 break;
    //               }
    //               if (chartSeries.data[i].originalIndex === ptIndex) {
    //                 ptIndex = i;
    //                 break;
    //               }
    //             }
    //           }
    //           dataPoint = chartSeries ? chartSeries.data[ptIndex] : null;
    //           updatePointColor(dataPoint, color);
    //         }
    //       }
    //     }
    //   });
    // }
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart-util.js